import { EXTERNAL_ACCESS_STORAGE, userTypes } from 'constants/externalAccess';
import searchParams from '../constants/searchParams';
import paths from 'constants/paths';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';

const getExternalAccess = () => {
  const externalAccess = localStorage.getItem(EXTERNAL_ACCESS_STORAGE);
  return JSON.parse(externalAccess || '{}');
};

const setOktaToken = (token) => {
  if (!token) return;
  const externalAccess = localStorage.getItem(EXTERNAL_ACCESS_STORAGE);
  const accessToken = {
    accessToken: token.token,
    tokenType: token.tokenType,
    scopes: token.scope,
  };

  const updatedAccessToken = {
    ...JSON.parse(externalAccess),
    accessToken: accessToken,
  };

  return localStorage.setItem(EXTERNAL_ACCESS_STORAGE, JSON.stringify(updatedAccessToken));
};

const setEmail = (clientEmail) => {
  if (!clientEmail) return;

  const externalAccess = localStorage.getItem(EXTERNAL_ACCESS_STORAGE);
  const updatedAccessToken = {
    ...JSON.parse(externalAccess),
    clientEmail: clientEmail,
  };
  return localStorage.setItem(EXTERNAL_ACCESS_STORAGE, JSON.stringify(updatedAccessToken));
};

const setKey = (accessKey) => {
  if (!accessKey) return;
  const externalAccess = localStorage.getItem(EXTERNAL_ACCESS_STORAGE);
  const updatedAccessToken = {
    ...JSON.parse(externalAccess),
    accessKey: accessKey,
  };
  return localStorage.setItem(EXTERNAL_ACCESS_STORAGE, JSON.stringify(updatedAccessToken));
};

const setAuth = (value) => {
  const externalAccess = localStorage.getItem(EXTERNAL_ACCESS_STORAGE);
  const updatedAccessToken = {
    ...JSON.parse(externalAccess),
    loggedIn: value,
  };
  return localStorage.setItem(EXTERNAL_ACCESS_STORAGE, JSON.stringify(updatedAccessToken));
};

export const setActivityLogInfo = (value) => {
  const externalAccess = localStorage.getItem(EXTERNAL_ACCESS_STORAGE);
  const updatedAccessToken = {
    ...JSON.parse(externalAccess),
    activityLogInfo: value,
  };
  return localStorage.setItem(EXTERNAL_ACCESS_STORAGE, JSON.stringify(updatedAccessToken));
};

export const defineType = (brokerNaId, naId) => {
  return brokerNaId === naId ? userTypes.readOnly : userTypes.interactive;
};

export const previewParam = (preview) => {
  return preview === 'true' ? `&${searchParams.preview}=true` : '';
};

export const checkIfExternalAccess = (pathname, params) =>
  pathname.includes(paths.externalAccess) ||
  (pathname.includes(paths.report) && params.get(searchParams.externalAccessKey));

export const checkIfReadOnlyMode = (na, externalAccessConfig, isExternalAccess) =>
  (!isExternalAccess && na.isExternal) ||
  (externalAccessConfig.readModeEnabled &&
    isExternalAccess &&
    externalAccessConfig.brokerNaId === na.id);

export const setAccessToken = (token) => setOktaToken(token);
export const setClientEmail = (email) => setEmail(email);
export const setAccessKey = (accessKey) => setKey(accessKey);
export const setLoggedIn = (value) => setAuth(value);
export const getExternalAccessTokenJWT = () => getExternalAccess()?.accessToken?.accessToken;
export const getExternalAccessStorage = () => getExternalAccess();
export const isExternalStorageAvailable = () =>
  !isEmpty(getExternalAccess()) &&
  !isUndefined(getExternalAccess().loggedIn) &&
  !isUndefined(getExternalAccess().clientEmail);
export const getExternalUser = () => {
  if (!isExternalStorageAvailable()) return null;
  const externalStorageEmail = getExternalAccess()?.clientEmail;
  return { email: externalStorageEmail, name: externalStorageEmail, uid: externalStorageEmail };
};
